import { NavLink, Outlet, useParams } from 'react-router-dom'
import ROUTES from '@/routes/routes'
import { ClockIcon, EnvelopeIcon } from '@heroicons/react/24/outline'
import { Bot, Coins, Key, Network } from 'lucide-react'
import { cn } from '@/lib/utils'

const CONFIG_TABS = [
  {
    to: (roomId: string) => ROUTES.PROFESSOR.ROOM_CONFIGURE_SCENARIO(roomId),
    label: 'Scenario & Events',
    icon: (
      <img
        src='/icons/settings.svg'
        alt=''
        className='h-[13px] w-[13px] flex-shrink-0'
      />
    ),
  },
  {
    to: (roomId: string) => ROUTES.PROFESSOR.ROOM_CONFIGURE_TIMERS(roomId),
    label: 'Rounds & Timers',
    icon: <ClockIcon className='h-[13px] w-[13px] flex-shrink-0' />,
  },
  {
    to: (roomId: string) =>
      ROUTES.PROFESSOR.ROOM_CONFIGURE_COMMUNICATIONS(roomId),
    label: 'Communications',
    icon: <EnvelopeIcon className='h-[13px] w-[13px] flex-shrink-0' />,
  },
  {
    to: (roomId: string) =>
      ROUTES.PROFESSOR.ROOM_CONFIGURE_RESOURCE_LIMITS(roomId),
    label: 'Resource Limits',
    icon: <Coins className='h-[13px] w-[13px] flex-shrink-0' />,
  },
  {
    to: (roomId: string) =>
      ROUTES.PROFESSOR.ROOM_CONFIGURE_SHARED_ADVISOR_SETTINGS(roomId),
    label: 'World Setup',
    icon: (
      <img
        src='/icons/settings.svg'
        alt=''
        className='h-[13px] w-[13px] flex-shrink-0'
      />
    ),
  },
  {
    to: (roomId: string) => ROUTES.PROFESSOR.ROOM_CONFIGURE_ADVISORS(roomId),
    label: 'Advisors',
    icon: (
      <img
        src='/icons/settings.svg'
        alt=''
        className='h-[13px] w-[13px] flex-shrink-0'
      />
    ),
  },
  {
    to: (roomId: string) => ROUTES.PROFESSOR.ROOM_CONFIGURE_AI_PLAYERS(roomId),
    label: 'AI Players',
    icon: <Bot className='h-[13px] w-[13px] flex-shrink-0' />,
  },
  {
    to: (roomId: string) => ROUTES.PROFESSOR.ROOM_CONFIGURE_API_ACCESS(roomId),
    label: 'API access',
    icon: <Key className='h-[13px] w-[13px] flex-shrink-0' aria-hidden />,
  },
  {
    to: (roomId: string) => ROUTES.PROFESSOR.ROOM_CONFIGURE_WORLD_GRAPH(roomId),
    label: 'World Graph',
    icon: <Network className='h-[13px] w-[13px] flex-shrink-0' aria-hidden />,
  },
  // Charter configuration now lives in the "Rounds & Timers" tab as Round 0.
]

export default function ConfigurationLayout() {
  const { roomId } = useParams<{ roomId: string }>()

  if (!roomId) {
    return (
      <div className='p-6 text-red-700 rounded-md bg-red-50'>
        <p>Error: Room ID is required</p>
      </div>
    )
  }

  return (
    <>
      <nav
        className='ml-24 flex gap-2 flex-wrap mb-2'
        aria-label='Configuration sections'
      >
        {CONFIG_TABS.map((tab) => (
          <NavLink
            key={tab.label}
            to={tab.to(roomId)}
            className={({ isActive }) =>
              cn(
                'inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-base font-medium transition-colors',
                isActive
                  ? 'bg-dark-blue text-white'
                  : 'bg-white text-dark-blue border border-gray-200 hover:bg-gray-50'
              )
            }
          >
            {tab.icon}
            <span>{tab.label}</span>
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </>
  )
}
